import React, { createContext, useContext, useState, useCallback } from 'react';

const STORAGE_KEY = 'em_theme';

export const DEFAULTS = {
  colorPrimary:  '#0a40d9',
  borderRadius:  10,
  mode:          'light',   // 'light' | 'dark'
  sidebarStyle:  'light',   // 'dark' | 'light' | 'colored'
};

const load = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    const saved = raw ? { ...DEFAULTS, ...JSON.parse(raw) } : { ...DEFAULTS };
    // Appearance customization removed — always force the current brand color,
    // light mode + light sidebar (ignores any stale persisted values).
    return { ...saved, colorPrimary: DEFAULTS.colorPrimary, mode: 'light', sidebarStyle: 'light' };
  } catch {
    return { ...DEFAULTS };
  }
};

export const ThemeContext = createContext({
  theme:    DEFAULTS,
  setTheme: () => {},
});

export const ThemeProvider = ({ children }) => {
  const [theme, setThemeState] = useState(load);

  const setTheme = useCallback((partial) => {
    setThemeState(prev => {
      const next = { ...prev, ...partial };
      localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
      return next;
    });
  }, []);

  return (
    <ThemeContext.Provider value={{ theme, setTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);
